const SITE_DATA = {};

function _insert(interfaceName, entity) {
  var _SITE_DATA$interfaceN;

  const insertValues = Array.isArray(entity) ? entity : [entity];
  const primaryKeys = new Set(insertValues.map(value => value.primaryKey()));
  const values = (_SITE_DATA$interfaceN = SITE_DATA[interfaceName]) !== null && _SITE_DATA$interfaceN !== void 0 ? _SITE_DATA$interfaceN : [];
  const newValues = [...values.filter(value => !primaryKeys.has(value.primaryKey())), ...insertValues];
  SITE_DATA[interfaceName] = newValues;
}

function _get(interfaceName, pk) {
  var _SITE_DATA$interfaceN2;

  const values = (_SITE_DATA$interfaceN2 = SITE_DATA[interfaceName]) !== null && _SITE_DATA$interfaceN2 !== void 0 ? _SITE_DATA$interfaceN2 : [];
  const matches = values.filter(value => value.primaryKey() === pk);
  return matches.at(0);
}

function _all(interfaceName) {
  var _SITE_DATA$interfaceN3;

  const values = (_SITE_DATA$interfaceN3 = SITE_DATA[interfaceName]) !== null && _SITE_DATA$interfaceN3 !== void 0 ? _SITE_DATA$interfaceN3 : [];
  return values;
}

function _remove(interfaceName, pk) {
  var _SITE_DATA$interfaceN4;

  const values = (_SITE_DATA$interfaceN4 = SITE_DATA[interfaceName]) !== null && _SITE_DATA$interfaceN4 !== void 0 ? _SITE_DATA$interfaceN4 : [];
  const newValues = values.filter(value => value.primaryKey() !== pk);
  SITE_DATA[interfaceName] = newValues;
}

export default Object.freeze({
  insert: _insert,
  get: _get,
  all: _all,
  remove: _remove
});